module.exports = __webpack_public_path__ + "img/join_content_2_title.e86696b2.png";